import { useState, useEffect } from 'react'

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search))

  useEffect(() => {
    const handlePopState = () => {
      setSearchParams(new URLSearchParams(window.location.search))
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const setQueryParam = (key: string, value: string) => {
    // const params = new URLSearchParams(searchParams)
    const params = new URLSearchParams(window.location.search)
    params.set(key, value)
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`)
  }

  const getQueryParam = (key: string) => {
    return searchParams.get(key)
  }

  const removeQueryParam = (key: string) => {
    const params = new URLSearchParams(searchParams)
    params.delete(key)
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`)
    setSearchParams(params)
  }

  return { setQueryParam, getQueryParam, removeQueryParam }
}

export default useQueryParams
